import Vue from "vue";
import store from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookie from "vue-cookie";
import VueRouter from "vue-router";
import moment from "moment";
import "moment-timezone";
import VueCurrencyFilter from "vue-currency-filter";
import LightBootstrap from "./light-bootstrap-main";
import VModal from "vue-js-modal";
import VueI18n from "vue-i18n";
import VueNumeric from "vue-numeric";
import Spain from "src/language/spain.js";
import Euskera from "src/language/euskera.js";
import English from "src/language/english.js";
import Portuguese from "src/language/portuguese.js";
import Catalan from "src/language/catalan.js";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings } from "luxon";
import "./store/store";
import CountryFlag from "vue-country-flag";
import VueCookies from "vue-cookies";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Settings.defaultLocale = "es";

// Plugins
import App from "./App.vue";

//LEA EL IDIOMA QUE QUIERE
//CAMBIAR LA VARIABLE web

// router setup
import routes from "./routes/routes";
// plugin setup
Vue.use(VueRouter);


Vue.use(LightBootstrap);
Vue.use(VueCookie);
Vue.use(VueAxios, axios);
Vue.use(VModal);
Vue.use(VueI18n);
Vue.use(VueNumeric);
Vue.use(Datetime);
Vue.component("country-flag", CountryFlag);
Vue.use(VueCookies);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
////////////////////////// IDIOMA /////////////////////////////
const getLang = (url) => {
  if (Vue.$cookies.isKey("language")) {
    return Vue.$cookies.get("language");
  } else {
    if (url.includes("numier.pt")) {
      return "pt";
    }
    return "es";
  }
};
let web = getLang(window.location.href);

moment.locale(web);

const messages = {
  es: Spain,
  pt: Portuguese,
  cat: Catalan,
  eus: Euskera,
  en: English,
};

const i18n = new VueI18n({
  locale: web,
  messages,
});

export const methods = {
  evitarComasDecimales: (event) => {
    if (event.keyCode != 229) {

      //console.log(event);
      // (,) & ( )
      if (event.keyCode == 32 || event.keyCode == 188) {
        event.preventDefault();
      }
    }
  },
}

Vue.prototype.$methods = methods;

Vue.use(VueCurrencyFilter, {
  symbol: "€",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "end",
  symbolSpacing: true,
});

Vue.filter("currencyGastos", function(value) { 

  return Intl.NumberFormat('es-ES', {style : 'currency', currency: 'EUR', minimumFractionDigits: 2}).format(value);

});

Vue.filter("formatCurrency", function (value) {
  if (value === "-" || value === "" || value === null || value === undefined) return ""; 
  if (!isNaN(value) && value !== null && value !== "") return `${parseFloat(value).toFixed(2)} €`; 
  return "";
});


Vue.filter("timeago", function(date) {
  if (date == 0) {
    return "Sin datos de última conexión";
  } else {
    let cambioHora = 0;
    if (store.getters.horaBusiness) {
      cambioHora = store.getters.horaBusiness;
    } else {
      cambioHora = 0;
    }
    let zone = "Europe/Madrid";

    if (cambioHora == -1) {
      // if el distribuidor es de canarias
      zone = "Atlantic/Canary";
    } else if (cambioHora == -7) {
      zone = "America/Guayaquil";
    }
    var humanDate = moment.unix(date);
    return moment.tz(humanDate, zone).fromNow();
  }
});

/*Vue.filter('timeagoSinqro', function (date) {
    if (date == 0) {
        return "Sin datos de última conexión";
    } else {

          let cambioHora=0;
          if(store.getters.horaBusiness){

              cambioHora=store.getters.horaBusiness;
          }
          else{

              cambioHora=0;
          }

          
        let zone = 'Europe/Madrid'

        if(cambioHora == -1){ 
            zone='Atlantic/Canary'
        }else if (cambioHora== -7){
            zone='America/Guayaquil'
        }

        date = moment(date).tz(zone).format('X');

        var humanDate = moment.unix(date-cambioHora*3600);

        return moment.tz(humanDate, zone).fromNow();
    }
});*/

Vue.filter('timago', function (date) {
    if (date == 0) {
        return "0 min.";
    } else {

        var hours = Math.floor(date / 60);
        var minutes = Math.floor((date % 60));


    var result = hours + " h. " + minutes + " min."; // 2:41:30

    return result;
  }
});

Vue.filter("diffHour", function(date) {
  if (date == 0) {
    return "0 min.";
  } else {
    var hours = Math.floor(date / 3600);
    var minutes = Math.floor((date - hours * 3600) / 60);
    var second = Math.floor(date - hours * 3600 - minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (second < 10) {
      second = "0" + second;
    }
    var result = hours + ":" + minutes + ":" + second; // 2:41:30

    return result;
  }
});

Vue.filter("parseDte", function(date) {
  if (date) {
    var humanDate = moment.unix(date);
    
    return moment.tz(humanDate, "Europe/Madrid").format("DD-MM-YYYY HH:mm");
  } else {
    return "";
  }
});

Vue.filter("parseDateNovedades", function(date) {
  if (date) {
    var humanDate = moment.unix(date);
    return moment.tz(humanDate, "Europe/Madrid").format("DD MMMM YYYY");
  } else {
    return "";
  }
});

Vue.filter("parseDateDelivery", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    var time = moment(new Date()).format("DD-MM-YYYY");

    if (moment.tz(humanDate, "Europe/Madrid").format("DD-MM-YYYY") === time) {
      return (
        "Hoy a las " + moment.tz(humanDate, "Europe/Madrid").format("HH:mm")
      );
    } else {
      return moment
        .tz(humanDate, "Europe/Madrid")
        .format("DD-MM-YYYY HH:mm:ss");
    }
  } else {
    return "";
  }
});

Vue.filter("parseDate", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /*  let cambioHora=0;

          if(store.getters.horaBusiness){

              cambioHora=store.getters.horaBusiness;
          }
          else{

              cambioHora=0;
          }

          //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
          let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

          //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
          let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);
  */
    // return  moment(humanDate.utcOffset(GMTBusiness)).format("DD-MM-YYYY");
    return moment.tz(humanDate, "Europe/Madrid").format("DD-MM-YYYY");
  } else {
    return "";
  }
});

Vue.filter("parseDateDia", function(date) {
  if (date) {
    var humanDate = moment.unix(date);
    humanDate = moment.tz(humanDate, "Europe/Madrid").format("dddd - DD/MM/YYYY")
    return humanDate.toUpperCase();
  } else {
    return "";
  }
});

Vue.filter("parseDateMinSlash", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    return moment.tz(humanDate, "Europe/Madrid").format("DD/MM/YYYY - HH:mm:ss");
  } else {
    return "";
  }
});

Vue.filter("parseDateMin", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /* let cambioHora=0;

         if(store.getters.horaBusiness===0){

             cambioHora=moment.tz(humanDate,'Europe/Madrid').format('Z');

             console.log("ENTRA 1",cambioHora);
         }else
         if(store.getters.horaBusiness){

             cambioHora=store.getters.horaBusiness;

             console.log("ENTRA 2",cambioHora);
         }
         else{
             cambioHora=moment.tz(humanDate,'Europe/Madrid').format('Z');
             console.log("ENTRA 3",cambioHora);
         }
         //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
         let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

         console.log( "GMT DEL SERVIDOR",GMTServidor);

         //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
         let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);

 */
    //return moment(humanDate.utcOffset(1)).format("DD-MM-YYYY HH:mm:ss");
    return moment.tz(humanDate, "Europe/Madrid").format("DD-MM-YYYY HH:mm:ss");
    
  } else {
    return "";
  }
});
Vue.filter("parseDateMinNovedades", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /* let cambioHora=0;

         if(store.getters.horaBusiness===0){

             cambioHora=moment.tz(humanDate,'Europe/Madrid').format('Z');

             console.log("ENTRA 1",cambioHora);
         }else
         if(store.getters.horaBusiness){

             cambioHora=store.getters.horaBusiness;

             console.log("ENTRA 2",cambioHora);
         }
         else{
             cambioHora=moment.tz(humanDate,'Europe/Madrid').format('Z');
             console.log("ENTRA 3",cambioHora);
         }
         //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
         let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

         console.log( "GMT DEL SERVIDOR",GMTServidor);

         //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
         let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);

 */
    //return moment(humanDate.utcOffset(1)).format("DD-MM-YYYY HH:mm:ss");
    return moment.tz(humanDate, "Europe/Madrid").format("DD MMMM YYYY HH:mm");
  } else {
    return "";
  }
});

Vue.filter("parseDateMomentMinut", function(date) {
  if (date) {
    return date.format("DD-MM-YYYY HH:mm:ss");
  } else {
    return "";
  }
});
Vue.filter("parseMomentMinut", function(date) {
  if (date) {
    return moment(date, "HH:mm:ss").format("HH:mm");
  } else {
    return "";
  }
});
Vue.filter("parseDiaSemana", function(num) {
  if (num) {
    const semana = {
      0: "Todos los domingos",
      1: "Todos los lunes",
      2: "Todos los martes",
      3: "Todos los miércoles",
      4: "Todos los jueves",
      5: "Todos los viernes",
      6: "Todos los sábados",
      7: "Todos los domingos",
    };
    return semana[num];
  } else {
    return "";
  }
});

Vue.filter("parseDateMoment", function(date) {
  if (date) {
    return date.format("DD-MM-YYYY");
  } else {
    return "";
  }
});

Vue.filter("parseMin", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /* let cambioHora=0;

         if(store.getters.horaBusiness){

             cambioHora=store.getters.horaBusiness;
         }
         else{

             cambioHora=0;
         }


         //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
         let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

         //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
         let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);
 */

    //return moment(humanDate.utcOffset(GMTBusiness)).format("HH:mm");
    return moment.tz(humanDate, "Europe/Madrid").format("HH:mm");
  } else {
    return "";
  }
});

Vue.filter("parseMinSec", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /* let cambioHora=0;

         if(store.getters.horaBusiness){

             cambioHora=store.getters.horaBusiness;
         }
         else{
             cambioHora=0;
         }

         //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
         let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

         //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
         let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);
 */

    //return moment(humanDate.utcOffset(GMTBusiness)).format("HH:mm:ss");
    return moment.tz(humanDate, "Europe/Madrid").format("HH:mm:ss");
  } else {
    return "";
  }
});

Vue.filter("parseDtoDecimal", function(num) {
  if (num) {
    return parseFloat(num).toFixed(2) + " %";
  } else {
    return "";
  }
});

Vue.filter("parseYear", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /*let cambioHora=0;

        if(store.getters.horaBusiness){

            cambioHora=store.getters.horaBusiness;
        }
        else{

            cambioHora=0;
        }*/

    //return moment(humanDate.utcOffset(cambioHora)).format("YYYY");
    return moment.tz(humanDate, "Europe/Madrid").format("YYYY");
  } else {
    return "";
  }
});

Vue.filter("parseMonth", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /* let cambioHora=0;

         if(store.getters.horaBusiness){

             cambioHora=store.getters.horaBusiness;
         }
         else{

             cambioHora=0;
         }

         //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
         let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

         //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
         let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);
 */

    //return moment(humanDate.utcOffset(GMTBusiness)).format("MMMM");
    return moment.tz(humanDate, "Europe/Madrid").format("MMMM");
  } else {
    return "";
  }
});

Vue.filter("parseHours", function(date) {
  if (date) {
    var humanDate = moment.unix(date);

    /*  let cambioHora=0;

          if(store.getters.horaBusiness){

              cambioHora=store.getters.horaBusiness;
          }
          else{

              cambioHora=0;
          }

          //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
          let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

          //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
          let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);*/

    // return moment(humanDate.utcOffset(GMTBusiness)).format("HH");
    return moment.tz(humanDate, "Europe/Madrid").format("HH");
  } else {
    return "";
  }
});
/*
Vue.filter('parseTipoRestriccionHoraria', function (tipo, list) {
        const elm = list.find(el=>{
            return el.value==tipo
        })
        return elm?elm.nombre:''
        
})*/
Vue.filter("parseBase", function(total, iva) {
  if (total) {
    return parseFloat(total) / (1 + iva / 100);
  } else {
    return parseFloat(0);
  }
});

Vue.filter("parseIVA", function(total, iva) {
  if (total) {
    return parseFloat(total) / (1 + iva / 100);
  } else {
    return parseFloat(0);
  }
});

Vue.filter("getDia", function(date) {
  if (date) {
    var dias = new Array("D", "L", "M", "X", "J", "V", "S");

    var humanDate = moment.unix(date);
    /*
                let cambioHora=0;

                if(store.getters.horaBusiness){

                    cambioHora=store.getters.horaBusiness;
                }
                else{

                    cambioHora=0;
                }

                //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
                let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');

                //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
                let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);

        */

    // return dias[moment(humanDate.utcOffset(GMTBusiness)).format("d")];
    return dias[moment.tz(humanDate, "Europe/Madrid").format("d")];
  } else {
    return "";
  }
});

//El de arriba es para ventas por negocio y el de abajo es para pasarela de pago
Vue.filter("getDiaDeSemana", function(date) {
  if (date) {
    var humanDate = moment.unix(date);
    //
    // let cambioHora=0;
    //
    // if(store.getters.horaBusiness){
    //
    //     cambioHora=store.getters.horaBusiness;
    // }
    // else{
    //
    //     cambioHora=0;
    // }
    //
    // //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
    // let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');
    //
    // //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
    // let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);

    //return moment(humanDate.utcOffset(GMTBusiness)).format("dddd");
    return moment.tz(humanDate, "Europe/Madrid").format("dddd");
  } else {
    return "";
  }
});

Vue.filter("getDiaSemana", function(date) {
  if (date) {
    if (typeof date == "string") {
      const Edate = date.split("-");
      date = new Date(Edate[2], Edate[1] - 1, Edate[0]);
    }
    //console.log(date);
    var humanDate = moment.unix(Math.floor(date / 1000));
    //
    // let cambioHora=0;
    //
    // if(store.getters.horaBusiness){
    //
    //     cambioHora=store.getters.horaBusiness;
    // }
    // else{
    //
    //     cambioHora=0;
    // }
    //
    // //GMT ESPAÑOLA, A PARTIR DE ELLA SACO EL GMT DE LOS DIFERENTES LUGARES A TRAVES DEL CAMBIO DE HORA DE LA TABLA DISTRIBUTORS
    // let GMTServidor=moment.tz(humanDate,'Europe/Madrid').format('Z');
    //
    // //GMT DE EL LUGAR DONDE SE ENCUENTRE EL NEGOCIO
    // let GMTBusiness=parseInt(GMTServidor.substring(0,3))+parseInt(cambioHora);

    //return moment(humanDate.utcOffset(GMTBusiness)).format("dddd");
    //console.log(moment.tz(humanDate, "Europe/Madrid").format("dddd"));
    let dia = moment.tz(humanDate, "Europe/Madrid").format("dddd");
    if (dia == "miércoles") {
      dia = "xmiércoles";
    }

    return dia;
  } else {
    return "";
  }
});

Vue.filter("getInitDia", function(date) {
  if (date) {
    return date[0].toUpperCase();
  } else {
    return "";
  }
});

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  store,
  router,
  i18n,
});
//console.log(store.state);
/* We import element-ui variables at the end so they can override the default element-ui colors */
import "./assets/sass/element_variables.scss";

// fix el-select for iOS
let fixElSelect = function () {
  document.querySelectorAll('.el-select[data-is-search="true"]:hover').forEach((v) => {
    let elInput = document.querySelector('.el-select[data-is-search="true"]:hover input[readonly]');
    if (elInput) {
      elInput.readOnly = false;
      elInput.blur();  // Pierde el foco para que luego el 'focus' lo recupere
      elInput.focus(); // Reactiva el campo y despliega el teclado
    }
  });
};

// Listeners para capturar eventos de enfoque e interacción táctil
document.addEventListener("focusin", fixElSelect);
document.addEventListener("click", fixElSelect);
document.addEventListener("touchstart", fixElSelect);




// WEBPACK FOOTER //
// ./src/main.js